module.exports = __webpack_public_path__ + "static/media/sickNote.a9021875.svg";